module.exports = __webpack_public_path__ + "static/media/profile.2665415e.png";